// extracted by mini-css-extract-plugin
module.exports = {"listContainer":"offers_listContainer__wPQrJ","list":"offers_list__zbuZZ","callToAction":"offers_callToAction__QI1yy","baseCopy":"offers_baseCopy__iQtn2"};